import {baseUrl} from'../config';

export const countryController ={
    GetAllCountries:baseUrl+'/api/country',
   
} 